// extracted by mini-css-extract-plugin
export default {"border":"FileUpload_border__Xtu3R","fileuploadcontainer":"FileUpload_fileuploadcontainer__w8xif","fileuploadbutton":"FileUpload_fileuploadbutton__5kwLt"};